import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IEventGeneralSettings } from '@sv/interfaces';
import { CustomAppService } from 'src/app/_services/_content/customApp.service';
import { GeneralSettingsService } from 'src/app/_services/_content/general-settings.service';

@Component({
  selector: 'app-landingpage',
  templateUrl: './landingpage.component.html',
  styleUrls: ['./landingpage.component.scss']
})
export class LandingpageComponent implements OnInit {
  generalSettings: IEventGeneralSettings;
  loaded = false;

  constructor(private customAppService: CustomAppService, private generalSettingsService: GeneralSettingsService, private router: Router) {}

  ngOnInit(): void {
    this.customAppService.getCustomAppListener().subscribe(async (app) => {
      if (typeof app.generalSettings === 'string') {
        this.generalSettings = await this.generalSettingsService.getGeneralSettings(app.generalSettings);
      } else {
        this.generalSettings = app.generalSettings;
      }

      if (!this.generalSettings.enableLP) {
        this.router.navigate(['/']);
      }
      this.loaded = true;
    });
  }
}
